(function () {
  var overlay = document.getElementById('search-overlay');
  var trigger = document.getElementById('search-trigger');
  var input = document.getElementById('search-overlay-input');
  var results = document.getElementById('search-overlay-results');
  var closeButtons = overlay ? overlay.querySelectorAll('[data-close-search]') : [];
  var debounceTimer;
  var abortController;

  if (!overlay || !trigger || !input || !results) return;

  function escapeHtml(value) {
    var element = document.createElement('span');
    element.textContent = value == null ? '' : String(value);
    return element.innerHTML;
  }

  function formatPrice(value) {
    var amount = Number.parseFloat(value);
    var currency = window.Shopify && window.Shopify.currency
      ? window.Shopify.currency.active
      : '';

    if (!Number.isFinite(amount) || !currency) return value;

    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: currency
      }).format(amount);
    } catch (error) {
      return value;
    }
  }

  function openSearch() {
    overlay.hidden = false;
    trigger.setAttribute('aria-expanded', 'true');
    document.body.classList.add('search-overlay-open');
    window.setTimeout(function () {
      input.focus();
    }, 50);
  }

  function closeSearch() {
    overlay.hidden = true;
    trigger.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('search-overlay-open');
    input.value = '';
    results.innerHTML = '';
    window.clearTimeout(debounceTimer);
    if (abortController) abortController.abort();
    trigger.focus();
  }

  function renderProducts(products, query) {
    var productRows = products.map(function (product) {
      var image = product.featured_image && product.featured_image.url
        ? '<img class="search-result-item__image" src="' + escapeHtml(product.featured_image.url) + '&width=112" alt="" width="56" height="56">'
        : '<span class="search-result-item__image search-result-item__image--placeholder" aria-hidden="true"></span>';

      return '<a class="search-result-item" href="' + escapeHtml(product.url) + '">' +
        image +
        '<span class="search-result-item__info">' +
          '<span class="search-result-item__title">' + escapeHtml(product.title) + '</span>' +
          '<span class="search-result-item__price">' + escapeHtml(formatPrice(product.price)) + '</span>' +
        '</span>' +
      '</a>';
    }).join('');

    if (!productRows) {
      results.innerHTML = '<p class="search-overlay__no-results">No products found</p>';
      return;
    }

    results.innerHTML = productRows +
      '<a href="/search?q=' + encodeURIComponent(query) + '&type=product" class="search-overlay__view-all">View all results <span aria-hidden="true">&rarr;</span></a>';
  }

  trigger.addEventListener('click', openSearch);
  closeButtons.forEach(function (button) {
    button.addEventListener('click', closeSearch);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && !overlay.hidden) closeSearch();
  });

  input.addEventListener('input', function () {
    window.clearTimeout(debounceTimer);
    var query = input.value.trim();

    if (abortController) abortController.abort();

    if (query.length < 2) {
      results.innerHTML = '';
      return;
    }

    results.innerHTML = '<p class="search-overlay__loading">Searching...</p>';

    debounceTimer = window.setTimeout(function () {
      abortController = new AbortController();
      var endpoint = '/search/suggest.json?q=' + encodeURIComponent(query) +
        '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last';

      fetch(endpoint, { signal: abortController.signal })
        .then(function (response) {
          if (!response.ok) throw new Error('Search request failed');
          return response.json();
        })
        .then(function (data) {
          var products = data.resources && data.resources.results
            ? data.resources.results.products || []
            : [];
          renderProducts(products, query);
        })
        .catch(function (error) {
          if (error.name !== 'AbortError') {
            results.innerHTML = '<p class="search-overlay__no-results">Search is unavailable. Please try again.</p>';
          }
        });
    }, 300);
  });
})();
